<template>
  <div class="scan-product-content">
    <div class="scan-title" v-if="codeList.length > 0">
      <div class="left">
        Sell-out：<span class="sellout-num">{{ codeList.length }} Pcs</span>
      </div>
      <div class="right" @click.stop="handleScan">
        <van-icon name="photo-o" class="scan-icon" size="16" />Re-upload
      </div>
    </div>
    <div v-if="codeList.length > 0" class="sn-code-content">
      <div v-for="(subItem, subIndex) in codeList" class="code-item" :class="{'no-code-item': subItem.status !== 0}" :key="subIndex">
        <div>
          <div class="sn-code">SN{{ subIndex + 1 }}: {{ subItem.code }}</div>
          <div v-if="subItem.status !== 0" class="sn-tips"><van-icon name="warning-o" /> {{ subItem.tips }}</div>
        </div>
        <van-icon name="delete-o" size="20" color="#a4a4a4" @click="delCode(subIndex)" />
      </div>
    </div>
    <div v-else class="example-content">
      <div class="error-tip" v-if="recognitionPrompt">
        <van-icon name="info-o" class="error-icon" color="#c4200b" size="16" />
        <!-- <span>识别失败，请按照下方示例图拍摄清晰漏出SN码的产品包装盒照片，再重新上传。</span> -->
        <span>Recognition failed. Please follow the example image below to take a clear photo of the product packaging that shows the SN code, then upload it again.</span>
      </div>
      <div class="example-txt">Example：</div>
      <img class="example-icon" src="@/assets/images/example_img.png" alt="" @click="previewImg">
    </div>
    <van-popup v-model="showScanner" position="bottom" :style="{ height: '100%' }">
      <barcode-scanner v-if="showScanner" @on-scan-success="onScanSuccess" @close="onScanClose" scanType="activityProduct" />
    </van-popup>
  </div>
</template>

<script>
import BarcodeScanner from '@/components/BarcodeScanner.vue'
import { Dialog, ImagePreview } from 'vant'
export default {
  components: {
    BarcodeScanner
  },
  props: {
    codeList: {
      type: Array,
      default: () => []
    },
    recognitionPrompt: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showScanner: false,
      exampleImg: require('@/assets/images/example_img.png')
    }
  },
  methods: {
    onScanSuccess (code) {
      this.snCode = code
      this.$emit('checkoutCode', code)
      this.showScanner = false
    },
    onScanClose () {
      this.showScanner = false
    },
    handleScan () {
      // this.showScanner = true
      this.$emit('checkoutCode')
    },
    delCode (index) {
      Dialog.confirm({
        message: 'Are you sure you want to delete this?',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel'
        // confirmButtonColor: '#d9001b'
      })
        .then(() => {
          this.codeList.splice(index, 1)
        })
        .catch(() => {
          // on cancel
        })
    },
    previewImg (url) {
      ImagePreview([this.exampleImg])
    }
  }
}
</script>

<style lang="less" scoped>
.scan-product-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  .scan-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 3px;
    border-bottom: 1px solid #eee;
    .left {
      font-size: 15px;
      font-weight: bold;
    }
    .right {
      color: #ee541b;
      font-size: 14px;
      padding: 5px 10px;
      border: 1px solid #ee541b;
      background: rgba(250, 205, 145, 0.33);
      .scan-icon {
        margin-right: 6px;
      }
    }
    .sellout-num {
      font-size: 15px;
      color: #ee541b;
    }
  }
  .sn-code-content {
    flex: 1;
    margin-top: 10px;
    // height: 366px;
    overflow-y: auto;
    .code-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 10px;
      background-color: #f2f2f2;
      color: #333;
      margin-bottom: 5px;
      .sn-code,
      .sn-tips {
        font-size: 14px;
      }
      .sn-tips {
        margin-top: 5px;
        color: #c4200b;
      }
    }
    .no-code-item {
      align-items: flex-start;
      border: 1px solid #c4200b;
      background-color: #f6bbc2;
    }
  }
  .example-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    .error-tip {
      color: #c4200b;
      font-size: 14px;
      margin-bottom: 10px;
      .error-icon {
        margin-right: 3px;
      }
    }
    .example-txt {
      margin-bottom: 10px;
      font-size: 16px;
    }
    .example-icon {
      width: 100%;
    }
  }
}
</style>
